export default __webpack_public_path__ + "static/media/Pistol_5.93eee39f.png";